module.exports = "/assets/data/0177d217334aa8ae93b0a36e98401a8d-EC3A.data.json";